export default "__VITE_ASSET__DOeMprOC__"